import { track } from '@farmersdog/analytics';

import { segmentTrackEvents } from '../segmentTrackEventNames';
import { AnalyticsFlow, AnalyticsSite } from '../types';

interface TrackRecipesViewedHowItWorksArgs {
  /** Daily-price-optimized regular order daily price amount in cents */
  oldDailyPlanPriceAmount: number | null | undefined;
  /** Daily-price-optimized regular order size in days */
  oldOrderSize: number | null | undefined;
  /** Order-price-optimized regular order daily price amount in cents */
  newDailyPlanPriceAmount: number | null | undefined;
  /** Order-price-optimized regular order size in days */
  newOrderSize: number | null | undefined;
}

/**
 * Track when a user views the "How it Works" module on the Recipes page.
 * Supports Default Plan Frequency experiment.
 * notion.so/thefarmersdog/1d755d8e446d8098b536cec9ca9d4b67
 */

export function trackRecipesViewedHowItWorks({
  oldDailyPlanPriceAmount,
  oldOrderSize,
  newDailyPlanPriceAmount,
  newOrderSize,
}: TrackRecipesViewedHowItWorksArgs) {
  track(segmentTrackEvents.module_viewed, {
    site: AnalyticsSite.Main,
    module_name: 'how it works',
    flow: AnalyticsFlow.Signup,
    oldDailyPlanPriceAmount,
    oldOrderSize,
    newDailyPlanPriceAmount,
    newOrderSize,
  });
}
